import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import CancelDialogIcon from "@entrilia/shared/icons/CancelDialogIcon";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDiscardChangesDialog = ({ open, onClose, onConfirm }: Props) => (
  <SmallDialog open={open} onClose={onClose}>
    <DialogTitle>Discard Changes</DialogTitle>
    <DialogCloseButton onClick={onClose} />

    <DialogContent>
      <Stack spacing={2} sx={{ alignItems: "center" }}>
        <CancelDialogIcon sx={{ width: 80, height: 80 }} />
        <Stack spacing={0.5} sx={{ alignItems: "center" }}>
          <Typography variant="h6">Discard unsaved changes?</Typography>
          <Typography color="textSecondary" sx={{ textAlign: "center" }}>
            Your unsaved changes will be lost.
          </Typography>
        </Stack>
      </Stack>
    </DialogContent>

    <DialogButtons onCancel={onClose} cancelText="Keep Editing">
      <Button variant="outlined" color="error" onClick={onConfirm}>
        Discard Changes
      </Button>
    </DialogButtons>
  </SmallDialog>
);

export default ConfirmDiscardChangesDialog;
